import React, { useState } from 'react';
import Dialog from 'screens/shared/dialog';
import {
  DialogContentText, Button,
} from '@mui/material';

import PasswordField from 'screens/shared/form/password-field';
import { getMyEmail, _t } from 'utils';
import { service } from '../../services';

export default ({
  show = false,
  title = 'Attention',
  message = _t('SHARED.CONFIRM_PASSWORD.MESSAGE'),
  onClose = null,
  yesButtonText = _t('SHARED.CONFIRM_PASSWORD.YES_BUTTON_LABEL'),
  noButtonText = _t('SHARED.CONFIRM_PASSWORD.NO_BUTTON_LABEL'),
}) => {
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');

  const onCloseConfirm = (value) => {
    setError('');
    setPass('');
    return onClose(value);
  };

  const yesButtonHandler = async () => {
    if (pass.length) {
      const email = getMyEmail();
      service.identity.checkPassword({ email, password: pass }).then(({ httpStatus }) => {
        if (httpStatus) {
          return setError(_t('SHARED.CONFIRM_PASSWORD.WRONG_PASSWORD_ERROR'));
        }
        return onCloseConfirm(true);
      });
    } else {
      return setError(_t('SHARED.CONFIRM_PASSWORD.WRONG_PASSWORD_ERROR'));
    }
    return true;
  };

  const actions = (
    <>
      <Button
        onClick={() => onCloseConfirm(false)}
        variant="contained"
        size="small"
      >
        {noButtonText}
      </Button>
      <Button
        onClick={yesButtonHandler}
        autoFocus
        variant="contained"
        size="small"
        // color="primary"
        style={{ background: 'var(--color-danger)', color: 'white' }}
      >
        {yesButtonText}
      </Button>
    </>
  );

  const content = (
    <div>
      <DialogContentText>
        {message}
      </DialogContentText>
      <PasswordField
        label={_t('SHARED.CONFIRM_PASSWORD.PASSWORD_FIELD.LABEL')}
        className="w-100p color-danger"
        value={pass}
        error={error}
        onChange={(e) => {
          setPass(e);
          setError('');
        }}
      />
    </div>
  );

  return (
    <Dialog
      show={show}
      actions={actions}
      content={content}
      title={<span style={{ color: 'var(--color-danger)' }}>{title}</span>}
      titleClassName="p-b-10"
      onClose={() => onCloseConfirm(false)}
      style={{}}
    />
  );
};
